import { render } from "./CompanyPasswordResetInputForm.vue?vue&type=template&id=5e697f45"
import script from "./CompanyPasswordResetInputForm.vue?vue&type=script&lang=js"
export * from "./CompanyPasswordResetInputForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__